(() => {
  const config = document.querySelector('[data-daisy-restock-config]');
  if (!config) return;
  const settings = JSON.parse(config.textContent);
  let active = false;
  window.DaisyRestockOffer = {
    discountedPrice(cents) {
      return active && Number.isFinite(cents) && cents >= 5000 ? cents - 5000 : null;
    },
    formatPrice(cents) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD',
        minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    },
  };
  if (!settings.enabled || settings.currency !== 'USD') return;
  const params = new URLSearchParams(location.search);
  const fromEmail = (params.get('offer') || '').toLowerCase() === 'restock26';
  const storageKey = 'daisy:restock26:email-visitor';
  let emailVisitor = fromEmail;
  try {
    if (fromEmail) localStorage.setItem(storageKey, '1');
    emailVisitor = emailVisitor || localStorage.getItem(storageKey) === '1';
  } catch {}
  if (!emailVisitor) return;
  let requestId = 0;
  const setActive = value => {
    active = value;
    document.dispatchEvent(new CustomEvent('daisy:restock-offer-ready'));
  };
  // Remember email attribution, but let the cart decide whether the offer still applies.
  const refresh = async (apply = false) => {
    const id = ++requestId;
    try {
      const response = await fetch(`${settings.root}${apply ? 'cart/update.js' : 'cart.js'}`, apply ? {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: 'Restock26' }),
      } : { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (id !== requestId) return;
      const code = cart.discount_codes?.find(item => item.code?.toLowerCase() === 'restock26');
      setActive(cart.currency === 'USD' && Boolean(code) && (cart.item_count === 0 || code.applicable === true));
    } catch { if (id === requestId) setActive(false); }
  };
  refresh(fromEmail);
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  window.addEventListener('focus', () => refresh());
})();
